<template>
  <div class="how_it_works">
    <div class="container">
      <div class="content">
        <h2 class="title" v-html="$t('how_it_works.title')"></h2>
        <div class="how_it_works_tabs">
          <div class="how_it_works_tabs-items">
            <div
              class="how_it_works_tabs-item"
              v-for="(tab, index) in tabs"
              @click="activeTab = index"
              :key="index"
              :class="{ '-active': activeTab === index }"
            >
              {{ tab.name }}
            </div>
          </div>
        </div>
        <div class="how_it_works_content">
          <div class="how_it_works_col">
            <div class="how_it_works_rate-label">
              {{ $t("how_it_works.minimal_rate") }}
            </div>
            <div class="how_it_works_rate-value">
              <img src="@/assets/images/arrow-circle-up.svg" alt="" />

              {{ $t("how_it_works.gesv", { rate: tabs[activeTab].max }) }}
            </div>
            <div class="how_it_works_rate-description">
              {{ $t("how_it_works.min_rate_description") }}
            </div>
          </div>
          <div class="how_it_works_col">
            <div class="how_it_works_rate-label">
              {{ $t("how_it_works.maximum_rate") }}
            </div>
            <div class="how_it_works_rate-value">
              <img src="@/assets/images/arrow-circle-down.svg" alt="" />
              <span>
                {{ $t("how_it_works.gesv", { rate: tabs[activeTab].min }) }}
              </span>
            </div>
            <div class="how_it_works_rate-description">
              {{ $t("how_it_works.max_rate_description") }}
            </div>
          </div>
          <div class="how_it_works_circle"></div>
        </div>
        <div class="how_it_works_bottom">
          <div class="how_it_works_caption">
            {{ $t("how_it_works.caption") }}
          </div>
          <a
            class="how_it_works_btn"
            target="_blank"
            :href="'/tariffs/deposit_card_tariffs_' + i18n().locale + '.pdf?v=0.1'"
          >
            {{ $t("how_it_works.details_link") }}
            <img src="@/assets/icons/download.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  methods: {
    i18n() {
      return i18n;
    },
  },
  data: () => ({
    activeTab: 0,
    tabs: [
      {
        name: "KZT",
        max: "13,8%",
        min: "0,10%",
      },
      {
        name: "USD",
        max: "1,00%",
        min: "0,10%",
      },
      {
        name: "EUR",
        max: "0,80%",
        min: "0,04%",
      },
      {
        name: "RUB",
        max: "1,00%",
        min: "0,04%",
      },
      {
        name: "CNY",
        max: "0,05%",
        min: "0,04%",
      },
      {
        name: "TRY",
        max: "0,05%",
        min: "0,04%",
      },
      {
        name: "KGS",
        max: "0,05%",
        min: "0,04%",
      },
      {
        name: "TJS",
        max: "0,05%",
        min: "0,04%",
      },
      {
        name: "UZS",
        max: "0,05%",
        min: "0,04%",
      },
      {
        name: "AED",
        max: "0,05%",
        min: "0,04%",
      },
    ],
  }),
};
</script>

<style scoped lang="scss">
.how_it_works {
  padding: rem(80) 0;
  background: linear-gradient(
      180deg,
      rgba(25, 195, 113, 0) 0%,
      rgba(25, 195, 113, 0.04) 49.82%,
      rgba(14, 50, 13, 0) 100%
    ),
    #0a0a0a;

  @include mobile {
    padding: rem(48) 0 0;
    background: none;
  }
  &-title {
    font-size: rem(64);
    font-weight: 700;
  }
  &_tabs {
    margin: rem(32) auto;
    &-items {
      display: flex;
      justify-content: center;
      width: max-content;
      background: #8794a314;
      padding: rem(4);
      border-radius: (rem(20));
      font-weight: 600;
    }
    &-item {
      color: #fff;
      cursor: pointer;
      line-height: 150%;
      padding: rem(12) rem(24);
      border-radius: rem(16);
      &.-active {
        background: #ffffff29;
      }
    }
    @include mobile {
      padding: 0 rem(16);
      overflow-x: scroll;
      max-width: 100vw;
      -ms-overflow-style: none;
      scrollbar-width: none;
      margin: rem(32) rem(-16);
      &::-webkit-scrollbar {
        display: none;
      }
      &-items {
        font-size: rem(14);
        border-radius: rem(16);
        justify-content: flex-start;
      }
      &-item {
        padding: rem(8) rem(16);
        border-radius: rem(12);
      }
    }
  }
  &_content {
    border-radius: rem(24);
    border: 1px solid rgba(224, 206, 196, 0.2);
    background: rgba(225, 237, 255, 0.04);
    padding: rem(40);
    color: #d9d9d9;
    display: flex;
    grid-column-gap: rem(48);
    position: relative;
    margin-bottom: rem(32);
    overflow: hidden;
    > .how_it_works_col {
      width: 100%;
      z-index: 2;
      position: relative;
    }
    @include mobile {
      flex-direction: column;
      padding: rem(20);
      grid-row-gap: rem(48);
    }
  }
  &_rate {
    &-label {
      margin-bottom: rem(12);
      font-size: rem(18);
    }
    &-value {
      font-size: rem(32);
      color: #fff;
      font-weight: 600;
      margin-bottom: rem(24);
      display: flex;
      align-items: center;
      gap: rem(12);
      span {
        background: linear-gradient(93deg, #1f8fce -10%, #3eef3b 50%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      @include mobile {
        font-size: rem(24);
      }
    }
    &-description {
      max-width: rem(440);
      line-height: 150%;
    }
  }
  &_caption {
    color: #ffffff80;
    line-height: 166%;
    font-size: rem(12);
    letter-spacing: 0.2px;
    margin-bottom: rem(12);
    @include mobile {
      margin-bottom: rem(20);
    }
  }
  &_btn {
    width: max-content;
    display: flex;
    align-items: center;
    color: #4ebc73;
    background: transparent;
    border: none;
    font-weight: 500;
    gap: rem(8);
    font-size: rem(16);
    cursor: pointer;
  }
  &_circle {
    position: absolute;
    right: -30%;
    top: -5%;
    border-radius: 9999px;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.88) 0%,
        rgba(0, 0, 0, 0.88) 100%
      ),
      linear-gradient(90deg, #3aff53 0%, #068fdb 80.74%, #009bde 80.74%);
    filter: blur(131.5px);
    width: 700px;
    height: 700px;
    @include mobile {
      width: 435px;
      height: 435px;
      top: 50%;
      border-radius: 436px;
      background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.88) 0%,
          rgba(0, 0, 0, 0.88) 100%
        ),
        linear-gradient(90deg, #3aff53 0%, #068fdb 80.74%, #009bde 80.74%);
      left: 50%;
      filter: blur(120px);
    }
  }
  &_bottom {
    @include mobile {
      padding: rem(20);
      border-radius: rem(24);
      border: 1px solid rgba(224, 206, 196, 0.2);
      background: #0c1113;
    }
  }
}
@include mobile {
  :deep(.title) {
    span {
      display: block;
    }
  }
}
</style>
